"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _v = _interopRequireDefault(require("uuid/v4"));
var _client = require("@apollo/client");
var _authSelectors = require("../auth/authSelectors");
var createAuthLink = function createAuthLink(store) {
  var requestGuidLink = new _client.ApolloLink(function (operation, next) {
    var token = (0, _authSelectors.accessTokenSelector)(store.getState());
    var context = operation.getContext();
    operation.setContext(Object.assign({
      headers: Object.assign({
        authorization: token ? "Bearer " + token : '',
        'request-guid': (0, _v.default)()
      }, context.headers)
    }, context));
    return next(operation);
  });
  return requestGuidLink;
};
var _default = exports.default = createAuthLink;